import React from "react";
import { Box, Button, Modal } from "@cloudscape-design/components";

const FutureInterventionDateModal = ({ error, onDismiss }) => (
  <Modal
    visible={Boolean(error)}
    onDismiss={onDismiss}
    closeAriaLabel="Close future start date message"
    header="Intervention has a future start date"
    footer={<Box float="right"><Button variant="primary" onClick={onDismiss}>OK</Button></Box>}
  >
    {error?.message}
  </Modal>
);

export default FutureInterventionDateModal;
